import BaseModal from '../../base-modal/BaseModal';
import { useStore } from 'src/contexts/StoreContext';
import { View } from 'react-native';
import { Illustration } from '../../../illustration/Illustration';
import { ILLUSTRATION_NAMES } from '../../../illustration/illustration.helper';
import { TestIDs } from 'src/constants/testIDs.constants';
import { DynamicModalProps } from '../DynamicModal.types';

export const ModalApplyAll = ({
  type,
  dynamicModalVisible,
  dynamicModalLayer: { onPressSaveChanges, id },
}: DynamicModalProps) => {
  const {
    i18n,
    dynamicModal: { closeModal },
    toolbarDesktop: { handleToggleClose },
  } = useStore();

  const handleConfirmButton = () => {
    onPressSaveChanges();
    closeModal();
    handleToggleClose({ onlyClose: true });
  };
  return (
    <BaseModal
      testID={TestIDs.APPLY_ALL}
      modalIcon={
        <View style={{ width: 100, height: 100 }}>
          <Illustration name={ILLUSTRATION_NAMES.Empty} />
        </View>
      }
      title={i18n.t('modal-apply-all:title')}
      confirmText={i18n.t('modal-apply-all:confirm')}
      discardText={i18n.t('modal-apply-all:abort')}
      handleConfirm={handleConfirmButton}
      handleDiscard={closeModal}
      isVisible={dynamicModalVisible}
      type={type}
      id={id}
    />
  );
};
